<div class="ion-padding">
  <h2 style="margin-top:0">Automatikus iktató</h2>
  <p style="color:var(--ion-color-medium)">Tölts fel egy beérkező PDF-et. A rendszer a szövegében keresi az ügyekhez rögzített hivatkozási számokat, és egyezés esetén automatikusan a megfelelő ügybe iktatja.</p>

  <ion-button [disabled]="feldolgozas" onclick="document.getElementById('iktatoFile').click()">
    <ion-spinner *ngIf="feldolgozas" slot="start" name="crescent"></ion-spinner>
    <ion-icon *ngIf="!feldolgozas" slot="start" name="cloud-upload"></ion-icon>
    PDF feltöltése
  </ion-button>
  <input id="iktatoFile" type="file" accept="application/pdf,.pdf" (change)="fajlValt($event)" hidden />

  <!-- SIKERES AUTO-IKTATÁS -->
  <ion-card *ngIf="eredmeny?.iktatva" color="success">
    <ion-card-header><ion-card-title><ion-icon name="checkmark-circle"></ion-icon> Beiktatva</ion-card-title></ion-card-header>
    <ion-card-content>
      Ügy: <b>{{ eredmeny.ugyazonosito }}</b> <span *ngIf="eredmeny.leiras">— {{ eredmeny.leiras }}</span>
      <div *ngIf="eredmeny.talalat?.length" style="margin-top:6px">Találat: {{ eredmeny.talalat.join(', ') }}</div>
      <div style="margin-top:10px">
        <ion-button size="small" (click)="ugyhoz(eredmeny.ugy_id)">Ügy megnyitása</ion-button>
        <ion-button size="small" fill="outline" (click)="ujLap()">Új PDF</ion-button>
      </div>
    </ion-card-content>
  </ion-card>

  <!-- NEM EGYÉRTELMŰ → KÉZI VÁLASZTÁS -->
  <ion-card *ngIf="eredmeny && !eredmeny.iktatva" color="warning">
    <ion-card-header><ion-card-title><ion-icon name="alert-circle"></ion-icon> Nincs egyértelmű találat</ion-card-title></ion-card-header>
    <ion-card-content>
      <div *ngIf="eredmeny.uresSzoveg" style="margin-bottom:8px">A PDF-ből nem sikerült szöveget kinyerni (lehet, hogy szkennelt kép). Válaszd ki kézzel az ügyet.</div>

      <div *ngIf="eredmeny.mintak?.length">
        <p style="margin:4px 0">Felismert azonosítók a dokumentumban:</p>
        <ion-chip *ngFor="let m of eredmeny.mintak" color="dark">{{ m }}</ion-chip>
        <p style="margin:4px 0;font-size:0.85em">Tipp: ha ez valamelyik ügyhöz tartozik, vedd fel hivatkozási számként, hogy legközelebb automatikus legyen.</p>
      </div>

      <div *ngIf="eredmeny.ugyek?.length">
        <p style="margin:8px 0 4px">Lehetséges ügyek (több egyezés):</p>
        <ion-button *ngFor="let u of eredmeny.ugyek" size="small" fill="outline" (click)="iktatIde(u.ugy_id)">{{ u.ugyazonosito }} — {{ u.leiras }}</ion-button>
      </div>

      <ion-item style="margin-top:8px">
        <ion-select label="Iktatás ügybe" labelPlacement="stacked" [(ngModel)]="valasztottUgy" interface="alert" placeholder="Válassz ügyet">
          <ion-select-option *ngFor="let u of ugyek" [value]="u.id">{{ u.ugyazonosito }} — {{ u.leiras }}</ion-select-option>
        </ion-select>
      </ion-item>
      <ion-button [disabled]="feldolgozas || !valasztottUgy" (click)="iktatIde(valasztottUgy)">
        <ion-spinner *ngIf="feldolgozas" slot="start" name="crescent"></ion-spinner>
        Iktatás a kiválasztott ügybe
      </ion-button>
      <ion-button fill="clear" (click)="ujLap()">Mégse</ion-button>
    </ion-card-content>
  </ion-card>

  <!-- HATÓSÁGOK -->
  <ion-list-header style="margin-top:24px"><ion-label>Hatóságok</ion-label></ion-list-header>
  <p style="color:var(--ion-color-medium);margin:0 16px">A hivatkozási számok besorolásához (pl. járásbírósági szám, törvényszéki szám).</p>
  <ion-list lines="full">
    <ion-item *ngFor="let h of hatosagok">
      <ion-icon slot="start" name="business" color="primary"></ion-icon>
      <ion-label>{{ h.nev }}</ion-label>
      <ion-button slot="end" fill="clear" color="danger" (click)="hatosagTorol(h)"><ion-icon name="trash"></ion-icon></ion-button>
    </ion-item>
  </ion-list>
  <ion-item>
    <ion-input label="Új hatóság" labelPlacement="stacked" [(ngModel)]="ujHatosag" placeholder="pl. Szombathelyi Törvényszék"></ion-input>
    <ion-button slot="end" (click)="hatosagAdd()">Hozzáad</ion-button>
  </ion-item>
</div>
